// extracted by mini-css-extract-plugin
module.exports = {"splash-header":"SplashHeader__splash-header___2t29X"};